import { render } from "./RequestUser.vue?vue&type=template&id=3381c386&scoped=true"
import script from "./RequestUser.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestUser.vue?vue&type=script&setup=true&lang=js"

import "./RequestUser.vue?vue&type=style&index=0&id=3381c386&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3381c386"],['__file',"src/pages/request/RequestUser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3381c386"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3381c386', __exports__)) {
    console.log('reload')
    api.reload('3381c386', __exports__)
  }
  
  module.hot.accept("./RequestUser.vue?vue&type=template&id=3381c386&scoped=true", () => {
    console.log('re-render')
    api.rerender('3381c386', render)
  })

}


export default __exports__